<nb-card class="dialog-modal-card" *ngIf="_userNameList!=null">
    <nb-card-header>Share Live View</nb-card-header>
    <nb-card-body>
        <div class="form-group">
            <div>
                <label for="formGroupExampleInput">Send Via</label>
            </div>
            <nb-radio-group id="violatio-enforcement-nmethod" name="method"  class="radio-group" #method="ngModel" [(ngModel)]="sendtype"  (valueChange)="onChange($event)" >
                <nb-radio value="user">User</nb-radio>
                <nb-radio value="email">Email</nb-radio>
                <nb-radio value="phone">Text Message</nb-radio>
            </nb-radio-group>
        </div>
   
        <div class="form-group"  *ngIf="sendtype=='user'">
            <label for="username" >Select Dispatch User:</label>
            <nb-select id="username" [class.pinhidden]="_mode =='admin'" name="username" *ngIf="_userNameList!=null"  #username="ngModel" fullWidth [(ngModel)]="_selectUser" >
            <nb-option *ngFor="let n of _userNameList" [value]="n.device">{{n.name}}({{n.device}})</nb-option>
        </nb-select>
        </div>
        <div class="form-group"  *ngIf="sendtype=='email'">
            <label for="txtEmail" *ngIf="sendtype=='email'">Email Address</label>
            <input type="text" class="form-control" id="txtEmail" name="txtEmail" placeholder="recipient@example.com" *ngIf="sendtype=='email'">
            <div class="alert alert-danger" *ngIf="checkEmailEmpty()" style="position: absolute; z-index: 100;">
                <div>Email is required</div>
            </div>
        </div>
        <div class="form-group" *ngIf="sendtype=='phone'">
            <label for="txtPhone" *ngIf="sendtype=='phone'">Phone Number</label>
            <input id="txtPhone" class="form-control" name="txtPhone" type="tel"  placeholder='Phone Number' *ngIf="sendtype=='phone'"  (keypress)="phoneNumberOnly($event)"
                ngModel #txtPhone="ngModel" [(ngModel)]="data.txtPhone" />
            <div class="alert alert-danger" *ngIf="data.sendtype=='phone' && ((submitted && phoneNumberError))" style="position: absolute; z-index: 100;">
                <div *ngIf="phoneNumberError">Please enter a valid phone number with at least 9 digits.</div>
            </div>
        </div>
        <div class="form-group"  *ngIf="sendtype=='email' || sendtype=='phone'">
            <label for="dtExpireDate">Expiration Date</label>
            <div class="datepicker-container">
                <input type="text" #datepicker [nbDatepicker]="dateTimePicker" class="form-control input-date"
                    id="txtDate" placeholder="Select a date" 
                    nbInput fullWidth  [(ngModel)]="data.txtDate" [ngModelOptions]="{ standalone: true }" readonly/>
                <nb-datepicker id="ndDate" #dateTimePicker [filter]="filterFn"></nb-datepicker>
            </div>
        </div>
        <div class="form-group"  *ngIf="sendtype=='email' || sendtype=='phone'">
            <label for="txtPass">Require PIN Code</label>
            <input type="password" class="form-control" id="txtPass" name="txtPass"   [(ngModel)]="data.txtPass" 
                placeholder="Enter 4-Digit PIN Code" ngModel #txtPass="ngModel"  minlength="4"  maxlength="4" (keypress)="numberOnly($event)"   />
            <div class="input alert alert-danger" *ngIf="(submitted && !txtPass.valid) || (txtPass.touched && !txtPass.valid)" style=" z-index: 100;">
                <div *ngIf="txtPass.errors.minlength">Pin should be minimum 4 characters.</div>
            </div>
        </div>
        <div class="form-group"  *ngIf="sendtype=='email' || sendtype=='phone'">
            <p class="red">Note: Shared live view sessions without an expiry date will automatically expire after 30 mins.</p>
        </div>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton class="auth" status="success" id="btnSend" (click)="sendRequest()">SHARE</button>
        <button nbButton status="danger" (click)="dismiss()">CANCEL</button>
        <button nbButton status="danger" class="hidden" id="btnClose{{device.device}}" (click)="dismiss()">CLOSE</button>
    </nb-card-footer>
</nb-card>